export const INITIAL_STATE = {
  linkVideo: '',
  played: '',
  isHasBeenWatched: false,
  isFirstLogin: false,
  lastLogin: null,
  username: '',
};
